import { createSelector } from '@ngrx/store';
import { getVirtualLocations } from '../getVirtualLocations';

export const getVirtualLocation = (locationNo: number) =>
    createSelector(getVirtualLocations, (virtualLocations) => virtualLocations?.find((virtualLocation) => virtualLocation.LocationNo === locationNo));
